export function generateReceiptNumber(): number {
  const randomSequentialNumber = Math.floor(Math.random() * 99999) + 1;
  return randomSequentialNumber;
}
